import { Collaborator } from 'core'

import { TrashIcon, VerticalDivider } from 'components/UI'

type Props = {
	members: Collaborator[]
	handleOpenRemoveMemberModal: (collaboratorUsername: string) => void
}

const MembersTable = ({ members, handleOpenRemoveMemberModal }: Props) => (
	<table class='mt-10 w-full table-auto border-b border-solid border-b-black-800'>
		<thead class='h-12 bg-black-800 text-black-100'>
			<tr>
				<th class='w-1/2 px-4 py-2 text-left text-[0.625rem] font-semibold'>
					Members
				</th>
				<th class='w-1/4 px-4 py-2 text-left text-[0.625rem] font-semibold'>
					Role
				</th>
				<th class='w-1/4 px-4 py-2 text-end text-[0.625rem] font-semibold'>
					Type
				</th>
			</tr>
		</thead>
		<tbody>
			{members.map(collaborator => (
				<tr class='h-12 border-t border-gray-700 text-black-100'>
					<td class='px-4 py-2 text-sm'>{collaborator.userHandler}</td>
					<td class='px-4 py-2 text-sm first-letter:uppercase'>
						{collaborator.role}
					</td>
					<td class='px-4 py-2 text-sm text-black-200 first-letter:uppercase'>
						<div class='flex items-center justify-end gap-5'>
							{collaborator.status}
							<VerticalDivider className='h-4' />
							<button
								aria-label='Remove member'
								onClick={() =>
									handleOpenRemoveMemberModal(collaborator.userHandler)
								}
								type='button'
							>
								<TrashIcon />
							</button>
						</div>
					</td>
				</tr>
			))}
		</tbody>
	</table>
)

export { MembersTable }
